import React from "react";
import { connect } from "react-redux";
import { Row, Col } from "antd";
import PropTypes from "prop-types";
import TitleNode from "./../../Components/CardComponent/TitleNode.js";
import CardComponent from "./../../Components/CardComponent/CardComponent.js";
import {
  DataVal,
  EmptyMessage
} from "./../../Components/CardComponent/styles.js";
import {
  ColumnHeader,
  ColumnValues,
  BalanceTable,
  ColumnValueFirst,
  Bsd,
  BalanceDiv,
  BalDataVal,
  PriceUnit,
  PoolTitleDesc,
  AmountDescGrid,
  BalDataValDesk,ColumnValuesBegEnd,UnitDescGrid,ColumnWrapDiv
} from "./styles";
import formatter from "./../../../../utils/formatter";
import { milliToDate } from "./../../../../utils/commonUtil";
import { replaceSelect } from "./../../../../utils/replacer";

const renderData = (data, property) => {
  if (property === "fromTo") {
    return (
      <div>
        <ColumnValueFirst paddingBottom="20px">
          <ColumnValues>From </ColumnValues>
        </ColumnValueFirst>
        <ColumnValues>To</ColumnValues>
      </div>
    );
  } else {
    return (
      <div>
        <ColumnValueFirst paddingBottom="20px">
          <ColumnValues>
            {(() => {
              let htmlArray = [];
              switch (property) {
                case "amount":
                case "nav":
                  if (data.from[property]) {
                    htmlArray.push(
                      formatter({
                        value: data.from[property],
                        fieldSuffix: "Dollars"
                      })
                    );
                  } else if (data.from[property] === 0) {
                    htmlArray.push("$0.00");
                  } else {
                    htmlArray.push("-");
                  }
                  break;
                case "date":
                  if (data.from[property]) {
                    htmlArray.push(milliToDate(data.from[property]));
                  } else {
                    htmlArray.push("-");
                  }
                  break;
                case "percentage":
                  if (data.from[property]) {
                    htmlArray.push(data.from[property] + "%");
                  } else if (data.from[property] === 0) {
                    htmlArray.push("0%");
                  } else {
                    htmlArray.push("-");
                  }
                  break;
                default:
                  if (data.from[property]) {
                    htmlArray.push(data.from[property]);
                  } else {
                    htmlArray.push("-");
                  }
                  break;
              }
              return htmlArray;
            })()}
          </ColumnValues>
        </ColumnValueFirst>
        <ColumnValueFirst paddingBottom="20px">
          <ColumnValues></ColumnValues>
        </ColumnValueFirst>
        <ColumnValueFirst paddingBottom="20px">
          <ColumnValues></ColumnValues>
        </ColumnValueFirst>
        <ColumnValueFirst paddingBottom="20px">
          <ColumnValues></ColumnValues>
        </ColumnValueFirst>
        <ColumnValueFirst paddingBottom="20px">
          <ColumnValues></ColumnValues>
        </ColumnValueFirst>
        <ColumnValueFirst paddingBottom="20px">
          <ColumnValues></ColumnValues>
        </ColumnValueFirst>
        <ColumnValues>
          {(() => {
            let htmlArray = [];
            switch (property) {
              case "amount":
              case "nav":
                if (data.to[property]) {
                  htmlArray.push(
                    formatter({
                      value: data.to[property],
                      fieldSuffix: "Dollars"
                    })
                  );
                } else if (data.to[property] === 0) {
                  htmlArray.push("$0.00");
                } else {
                  htmlArray.push("-");
                }
                break;
              case "date":
                if (data.to[property]) {
                  htmlArray.push(milliToDate(data.to[property]));
                } else {
                  htmlArray.push("-");
                }
                break;
              case "percentage":
                if (data.to[property]) {
                  htmlArray.push(data.to[property] + "%");
                } else if (data.to[property] === 0) {
                  htmlArray.push("0%");
                } else {
                  htmlArray.push("-");
                }
                break;
              default:
                if (data.to[property]) {
                  htmlArray.push(data.to[property]);
                } else {
                  htmlArray.push("-");
                }
                break;
            }
            return htmlArray;
          })()}
        </ColumnValues>
      </div>
    );
  }
};
const renderNav = data => {
  return (
    <ColumnWrapDiv>
      <ColumnValueFirst paddingBottom="20px">
        <ColumnValuesBegEnd>
          {data.fromNav
            ? formatter({
                value: data.fromNav,
                fieldSuffix: "Dollars"
              })
            : data.fromNav === 0
            ? "$0.00"
            : "-"}
        </ColumnValuesBegEnd>
      </ColumnValueFirst>
      <ColumnValueFirst style={{ visibility: "hidden" }} paddingBottom="20px">
        <ColumnValues>Grant</ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst style={{ visibility: "hidden" }} paddingBottom="20px">
        <ColumnValues>Contribution</ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst style={{ visibility: "hidden" }} paddingBottom="20px">
        <ColumnValues>exchange</ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst style={{ visibility: "hidden" }} paddingBottom="20px">
        <ColumnValues>Other</ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst style={{ visibility: "hidden" }} paddingBottom="20px">
        <ColumnValues>MM</ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst>
        <ColumnValuesBegEnd>
          {data.nav
            ? formatter({
                value: data.nav,
                fieldSuffix: "Dollars"
              })
            : data.nav === 0
            ? "$0.00"
            : "-"}
        </ColumnValuesBegEnd>
      </ColumnValueFirst>
    </ColumnWrapDiv>
  );
};
const renderAmount = data => {
  return (
  <ColumnWrapDiv>
      <ColumnValueFirst paddingBottom="20px">
        <ColumnValuesBegEnd>
          {data.fromAmount
            ? AmountFormatter(data.fromAmount): "$0.00"}
        </ColumnValuesBegEnd>
      </ColumnValueFirst>
      <ColumnValueFirst paddingBottom="20px">
        <ColumnValues>
          {data.contributionAmount && data.contributionAmount > 0
            ? AmountFormatter(data.contributionAmount)
            : data.contributionAmount < 0
            ? "(" + AmountFormatter(data.contributionAmount)+ ")"
            : "$0.00"}
        </ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst paddingBottom="20px">
        <ColumnValues>
          {data.grantAmount && data.grantAmount > 0
            ? AmountFormatter(data.grantAmount)
            : data.grantAmount < 0
            ? "(" + AmountFormatter(data.grantAmount) + ")"
            : "$0.00"}
        </ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst paddingBottom="20px">
        <ColumnValues>
          {data.exchangeAmount && data.exchangeAmount > 0
            ? AmountFormatter(data.exchangeAmount)
            : data.exchangeAmount < 0
            ? "(" + AmountFormatter(data.exchangeAmount) + ")"
            : "$0.00"}
        </ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst paddingBottom="20px">
        <ColumnValues>
          {data.otherAmount && data.otherAmount > 0
            ? AmountFormatter(data.otherAmount)
            : data.otherAmount < 0
            ? "(" + AmountFormatter(data.otherAmount) + ")"
            : "$0.00"}
        </ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst paddingBottom="20px" >
        <ColumnValues>
          {data.marketMovement && data.marketMovement > 0
            ? AmountFormatter(data.marketMovement)
            : data.marketMovement < 0
            ? "(" + AmountFormatter(data.marketMovement) + ")"
            : "$0.00"}{" "}
        </ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst>
        <ColumnValuesBegEnd>
          {data.amount
            ? AmountFormatter(data.amount)
            : "$0.00"}
        </ColumnValuesBegEnd>
      </ColumnValueFirst>
    </ColumnWrapDiv>
  );
};
const UnitsFormatter = data =>{
  let val;
  { data <0 ?
  ( val = formatter({
    value: Math.abs(data),
    fieldSuffix: "Units"
  }) ):
  ( val = formatter({
    value: data,
    fieldSuffix: "Units"
  }))
  return val
}
}
const AmountFormatter = data =>{
  let val;
  { data <0 ?
  ( val = formatter({
    value: Math.abs(data),
    fieldSuffix: "Dollars"
  }) ):
  ( val = formatter({
    value: data,
    fieldSuffix: "Dollars"
  }))
  return val
}
}
const renderPercentage = data => {
  return (
    <ColumnWrapDiv>
      <ColumnValueFirst paddingBottom="20px">
        <ColumnValuesBegEnd>
          {data.fromPercentage
            ? formatter({
              value: data.fromPercentage,
              fieldSuffix: "PercentWDecimal"
            })
            : "0.00%"}
        </ColumnValuesBegEnd>
      </ColumnValueFirst>
      <ColumnValueFirst style={{ visibility: "hidden" }} paddingBottom="20px">
        <ColumnValues>grants</ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst style={{ visibility: "hidden" }} paddingBottom="20px">
        <ColumnValues>contribution</ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst style={{ visibility: "hidden" }} paddingBottom="20px">
        <ColumnValues>exchange</ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst style={{ visibility: "hidden" }} paddingBottom="20px">
        <ColumnValues>other</ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst style={{ visibility: "hidden" }} paddingBottom="20px">
        <ColumnValues>mm</ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst>
        <ColumnValuesBegEnd>
          {data.percentage
            ? formatter({
              value: data.percentage,
              fieldSuffix: "PercentWDecimal"
            })
            : "0.00%"}
        </ColumnValuesBegEnd>
      </ColumnValueFirst>
    </ColumnWrapDiv>
  );
};
const renderUnits = data => {
  return (
    <ColumnWrapDiv>
      <ColumnValueFirst paddingBottom="20px">
        <ColumnValuesBegEnd>
          {data.fromUnits && data.fromUnits > 0
            ? UnitsFormatter(data.fromUnits)
            : data.fromUnits < 0
            ? "(" + UnitsFormatter(data.fromUnits) + ")"
            : "-"}
        </ColumnValuesBegEnd>
      </ColumnValueFirst>
      <ColumnValueFirst paddingBottom="20px">
        <ColumnValues>
          {data.contributionUnits && data.contributionUnits > 0
            ? UnitsFormatter(data.contributionUnits)
            : data.contributionUnits < 0
            ? "(" + UnitsFormatter(data.contributionUnits) + ")"
            : "-"}
        </ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst paddingBottom="20px">
        <ColumnValues>
          {data.grantsUnits && data.grantsUnits > 0
            ? UnitsFormatter(data.grantsUnits)
            : data.grantsUnits < 0
            ? "(" + UnitsFormatter(data.grantsUnits) + ")"
            : "-"}
        </ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst paddingBottom="20px">
        <ColumnValues>
          {data.exchangeUnits && data.exchangeUnits > 0
            ? UnitsFormatter(data.exchangeUnits)
            : data.exchangeUnits < 0
            ? "(" + UnitsFormatter(data.exchangeUnits) + ")"
            : "-"}
        </ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst paddingBottom="20px">
        <ColumnValues>
          {data.otherUnits && data.otherUnits > 0
            ? UnitsFormatter(data.otherUnits)
            : data.otherUnits < 0
            ? "(" + UnitsFormatter(data.otherUnits) + ")"
            : "-"}
        </ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst style={{ visibility: "hidden" }} paddingBottom="20px">
        <ColumnValues>MM</ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst>
        <ColumnValuesBegEnd>
          {data.units && data.units > 0
            ? UnitsFormatter(data.units)
            : data.units < 0
            ? "(" + UnitsFormatter(data.units) + ")"
            : "-"}
        </ColumnValuesBegEnd>
      </ColumnValueFirst>
    </ColumnWrapDiv>
  );
};

const renderDescription = () => {
  return (
    <div>
      <ColumnValueFirst paddingBottom="20px">
        <ColumnValuesBegEnd>Beginning Balance</ColumnValuesBegEnd>
      </ColumnValueFirst>
      <ColumnValueFirst paddingBottom="20px">
        <ColumnValues>Contributions</ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst paddingBottom="20px">
        <ColumnValues>Grants</ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst paddingBottom="20px">
        <ColumnValues>Exchanges</ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst paddingBottom="20px">
        <ColumnValues>Other Transactions</ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst paddingBottom="20px">
        <ColumnValues>Market Movement</ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst>
        <ColumnValuesBegEnd>Ending Balance</ColumnValuesBegEnd>
      </ColumnValueFirst>
    </div>
  );
};

const renderTitleGrid = pool => {
  return <BalDataValDesk>{replaceSelect(pool)}</BalDataValDesk>;
};
const renderTitleGridMob = pool => {
  return (
    <PoolTitleDesc >
      {" "}
      <TitleNode title="Pool Name" /> <BalDataVal>{replaceSelect(pool)}</BalDataVal>
    </PoolTitleDesc>
  );
};
const renderUnitGrid = data => {
  return (
    <>
    <UnitDescGrid>
      <BalanceDiv>
        <Bsd>
          <TitleNode title="Description" />
        </Bsd>
        <Bsd>
          <TitleNode title="Units" />
        </Bsd>
      </BalanceDiv>
      <BalanceDiv>
        <Bsd>
          <DataVal>Contributions</DataVal>
        </Bsd>
        <Bsd>
          <DataVal>
              {data.contribution.units && data.contribution.units  > 0
            ? UnitsFormatter(data.contribution.units)
            : data.contribution.units  < 0
            ? "(" + UnitsFormatter(data.contribution.units) + ")"
            : "-"}
          </DataVal>
        </Bsd>
      </BalanceDiv>
      <BalanceDiv>
        <Bsd>
          <DataVal>Grants</DataVal>
        </Bsd>
        <Bsd>
          <DataVal>
            {data.grant.units && data.grant.units  > 0
            ? UnitsFormatter(data.grant.units)
            : data.grant.units  < 0
            ? "(" + UnitsFormatter(data.grant.units) + ")"
            : "-"}
          </DataVal>
        </Bsd>
      </BalanceDiv>
      <BalanceDiv>
        <Bsd>
          <DataVal>Exchanges</DataVal>
        </Bsd>
        <Bsd>
          <DataVal>
              {data.exchange.units && data.exchange.units  > 0
            ? UnitsFormatter(data.exchange.units)
            : data.exchange.units  < 0
            ? "(" + UnitsFormatter(data.exchange.units) + ")"
            : "-"}
          </DataVal>
        </Bsd>
      </BalanceDiv>
      <BalanceDiv>
        <Bsd>
          <DataVal>Other Transactions</DataVal>
        </Bsd>
        <Bsd>
          <DataVal>
          {data.other.units && data.other.units  > 0
            ? UnitsFormatter(data.other.units)
            : data.other.units  < 0
            ? "(" + UnitsFormatter(data.other.units) + ")"
            : "-"}
          </DataVal>
        </Bsd>
      </BalanceDiv>      
      </UnitDescGrid>
    </>
  );
}
const renderAmountGrid = data => {
  return (
    <>
    <AmountDescGrid>
      <BalanceDiv>
        <Bsd>
          <TitleNode title="Description" />
        </Bsd>
        <Bsd>
          <TitleNode title="Amount" />
        </Bsd>
      </BalanceDiv>
      <BalanceDiv>
        <Bsd>
          <DataVal>Contributions</DataVal>
        </Bsd>
        <Bsd>
          <DataVal>
            {data.contribution.amount && data.contribution.amount > 0
              ? AmountFormatter(data.contribution.amount)
              : data.contribution.amount < 0
              ? "(" + AmountFormatter(data.contribution.amount) + ")"
              : "$0.00"}
          </DataVal>
        </Bsd>
      </BalanceDiv>
      <BalanceDiv>
        <Bsd>
          <DataVal>Grants</DataVal>
        </Bsd>
        <Bsd>
          <DataVal>
            {data.grant.amount && data.grant.amount > 0
              ? AmountFormatter(data.grant.amount)
              : data.grant.amount < 0
              ? "(" + AmountFormatter(data.grant.amount) + ")"
              : "$0.00"}{" "}
          </DataVal>
        </Bsd>
      </BalanceDiv>
      <BalanceDiv>
        <Bsd>
          <DataVal>Exchanges</DataVal>
        </Bsd>
        <Bsd>
          <DataVal>
            {data.exchange.amount && data.exchange.amount > 0
              ? AmountFormatter(data.exchange.amount)
              : data.exchange.amount < 0
              ? "(" + AmountFormatter(data.exchange.amount) + ")"
              : "$0.00"}{" "}
          </DataVal>
        </Bsd>
      </BalanceDiv>
      <BalanceDiv>
        <Bsd>
          <DataVal>Other Transactions</DataVal>
        </Bsd>
        <Bsd>
          <DataVal>
            {data.other.amount && data.other.amount > 0
              ? AmountFormatter(data.other.amount)
              : data.other.amount < 0
              ? "(" + AmountFormatter(data.other.amount) + ")"
              : "$0.00"}{" "}
          </DataVal>
        </Bsd>
      </BalanceDiv>
      <BalanceDiv>
        <Bsd>
          <DataVal>Market Movement</DataVal>
        </Bsd>
        <Bsd>
          <DataVal>
            {data.marketMovement && data.marketMovement > 0
              ? AmountFormatter(data.marketMovement)
              : data.marketMovement < 0
              ? "(" + AmountFormatter(data.marketMovement) + ")"
              : "$0.00"}{" "}
          </DataVal>
        </Bsd>
      </BalanceDiv>
      </AmountDescGrid>
    </>
  );
};
const renderFromGrid = (data, type) => {
  return (
    <>
      <BalanceDiv>
        <Bsd>
          <TitleNode title="Description" />
          <DataVal>{type === 'from' ? 'Begninning Balance' : 'Ending      Balance'}</DataVal>
        </Bsd>

        <Bsd>
          <TitleNode title="Amount" />
          <DataVal>
            {data.amount
              ? formatter({
                  value: data.amount,
                  fieldSuffix: "Dollars"
                })
              : "$0.00"}
          </DataVal>
        </Bsd>
      </BalanceDiv>
      <BalanceDiv>
        <Bsd>
          <TitleNode title="Units" />
          <DataVal>
            {data.units && data.units > 0
              ? UnitsFormatter(data.units)
              : data.units < 0
              ? "(" + UnitsFormatter(data.units) + ")"
              : "0.00"}
          </DataVal>
        </Bsd>
        <Bsd>
          <TitleNode title="NAV" />
          <DataVal>
            {data.nav
              ? formatter({
                  value: data.nav,
                  fieldSuffix: "Dollars"
                })
              : data.nav === 0
              ? "$0.00"
              : "-"}
          </DataVal>
        </Bsd>
      </BalanceDiv>
      <BalanceDiv>
        <Bsd>
          <TitleNode title="Percentage" />
          <DataVal>
            {data.percentage
              ? formatter({
                value: data.percentage,
                fieldSuffix: "PercentWDecimal"
              })
              : "0.00%"}
          </DataVal>
        </Bsd>
      </BalanceDiv>
    </>
  );
};

export const BalanceDetailsTable = props => {
  let balanceData = [];
  if (props.filterData) {
    for (var key in props.filterData) {
      if (props.filterData.hasOwnProperty(key)) {
        balanceData.push({
          option: key,
          from: props.filterData[key].from,
          to: props.filterData[key].to,
          contribution: props.filterData[key].contribution,
          exchange: props.filterData[key].exchange,
          grant: props.filterData[key].grant,
          other: props.filterData[key].other,
          marketMovement: props.filterData[key].marketMovement
        });
      }
    }
  }

  const destObj = each => {
    return [
      {
        name: "option",
        gridWidth: "100",
        type: "FixGrid",
        render: renderTitleGridMob(each.option),
        ptop: false,
        pbottom: false,
        pright: true
      },
      {
        name: "from",
        gridWidth: "100",
        type: "FixGrid",
        render: renderFromGrid(each.from, "from"),
        ptop: false,
        pbottom: false,
        pright: true
      },

      {
        name: "DescAmount",
        type: "FixGrid",
        gridWidth: "100",
        render: renderAmountGrid(each),
        ptop: false,
        pbottom: false,
        pright: true
      },
      {
        name: "DescUnits",
        type: "FixGrid",
        gridWidth: "100",
        render: renderUnitGrid(each),
        ptop: false,
        pbottom: false,
        pright: true
      },
      {
        name: "to",
        type: "FixGrid",
        gridWidth: "100",
        render: renderFromGrid(each.to, "to"),
        ptop: false,
        pbottom: true,
        pright: true
      }
    ];
  };

  const columns = [
    {
      title: <ColumnHeader>Pool Name</ColumnHeader>,
      render: renderTitleGrid,
      dataIndex: "option",
      key: "option",
      width: "200px"
    },
    {
      title: <ColumnHeader>Description</ColumnHeader>,
      render: renderDescription,
      dataIndex: "fromTo",
      key: "fromTo"
    },
    {
      title: <ColumnHeader>Amount</ColumnHeader>,
      render: renderAmount,
      key: "amount",
      width: "140px"
    },
    {
      title: <ColumnHeader>Units</ColumnHeader>,
      render: renderUnits,
      key: "units",
      width: "140px"
    },
    {
      title: <ColumnHeader>NAV</ColumnHeader>,
      render: renderNav,
      key: "nav",
      width: "140px"
    },
    {
      title: <ColumnHeader>Percentage</ColumnHeader>,
      render: renderPercentage,
      key: "percentage",
      width: "140px"
    }
  ];

  let mainData = [];
  if (balanceData) {
    balanceData.map(data => {
      mainData.push({
        option: data.option,
        fromTo: renderData(data, "fromTo"),
        fromAmount: data.from.amount,
        amount: data.to.amount,
        date: renderData(data, "date"),
        fromDate: data.from.date,
        units: data.to.units,
        fromUnits: data.from.units,
        nav: data.to.nav,
        fromNav: data.from.nav,
        percentage: data.to.percentage,
        fromPercentage: data.from.percentage,
        marketMovement: data.marketMovement,
        contributionAmount: data.contribution.amount,
        grantAmount: data.grant.amount,
        exchangeAmount: data.exchange.amount,
        otherAmount: data.other.amount,
        contributionUnits: data.contribution.units,
        grantsUnits: data.grant.units,
        exchangeUnits: data.exchange.units,
        otherUnits: data.other.units
      });
      return true;
    });
  }

  let dataMob = [];
  if (balanceData) {
    balanceData.map(data => {
      dataMob.push({
        option: data.option,
        from: data.from,
        to: data.to,
        contribution: data.contribution,
        grant: data.grant,
        exchange: data.exchange,
        other: data.other,
        marketMovement: data.marketMovement
      });
      return true;
    });
  }

  return (
    <Row data-test="transaction-balance-details-table">
      <Col lg={24} md={0} xs={0}>
        <BalanceTable
          data-test="transaction-balance-details-table-column"
          pagination={false}
          style={{ width: "100%" }}
          columns={columns}
          dataSource={mainData}
          scroll={{ y: 500 }}
          locale={{
            emptyText: (
              <div class="ant-empty ant-empty-normal">
                <EmptyMessage class="ant-empty-description">
                  There is no account balance history for the selected time
                  frame.
                </EmptyMessage>
              </div>
            )
          }}
        />
      </Col>
      <Col lg={0} md={24} xs={24}>
        <CardComponent
          data-test="transaction-balance-details-table-destobj"
          tabName="account_balance"
          destObj={destObj}
          data={dataMob}
        />
      </Col>
    </Row>
  );
};

BalanceDetailsTable.propTypes = {
  filterData: PropTypes.object,
  balanceDetails: PropTypes.object
};

const mapStateToProps = state => ({
  filterData: state.getIn([
    "transactionSummary",
    "filterData",
    "data",
    "sortedBalanceDetails"
  ]),
  balanceDetails: state.getIn(["transactionSummary", "balanceDetails", "data"])
});

export default connect(mapStateToProps)(BalanceDetailsTable);
